import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VendorDashboardAction } from "../../../Redux/action/VendorDashboardAction";
import {
  FaEllipsisH,
  FaEye,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";
import { IoSearch } from "react-icons/io5";
import { FiFilter } from "react-icons/fi";
import { Button, Modal, Spinner } from "react-bootstrap";
import { MdDelete, MdAddTask } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../Common/Pagination/Pagination";
import noImage from "../../../images/dummy_dp.png";
import {
  ActivateVendor,
  DeactivateVendor,
} from "../../../Services/vendorServices";

const VendorPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [pageNumber, setPageNumber] = useState(0);
  const [size] = useState(10);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState(location?.state?.active ?? "ALL");
  const [filterActive, setFilterActive] = useState("ALL");
  const [id, setId] = useState(null);
  const [activateModal, setActivateModal] = useState(false);
  const [deactivateModal, setDeactivateModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showOptionsForId, setShowOptionsForId] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const loader = useSelector((state) => state?.VendorSideDashboard?.loading);
  const vendorData = useSelector(
    (state) => state?.VendorSideDashboard?.result?.content || []
  );
  const totalPages = useSelector(
    (state) => state?.VendorSideDashboard?.result?.totalPages
  );

  const optionsRef = useRef(null);

  useEffect(() => {
    dispatch(
      VendorDashboardAction({
        pageNumber,
        size,
        search,
        activeTab,
        filterActive,
      })
    );
  }, [
    pageNumber,
    search,
    activeTab,
    activateModal,
    deactivateModal,
    filterActive,
  ]);

  useEffect(() => setPageNumber(0), [search]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setShowOptionsForId(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleActivate = () => {
    setIsLoading(true);
    ActivateVendor(id).finally(() => {
      setIsLoading(false);
      setActivateModal(false);
    });
  };

  const handleDeactivate = () => {
    setIsLoading(true);
    DeactivateVendor(id).finally(() => {
      setIsLoading(false);
      setDeactivateModal(false);
    });
  };

  const toggleOptions = (vendorId) =>
    setShowOptionsForId(showOptionsForId === vendorId ? null : vendorId);
  const handlePageChange = (page) => setPageNumber(page);

  const tableHeaders = [
    { label: "Company Name" },
    { label: "Founder Name" },
    { label: "Email" },
    { label: "Address" },
    { label: "Verified" },
    { label: "Account Status" },
    { label: "Action" },
  ];

  const tableCellStyle = {
    padding: "0.5rem",
    fontSize: "14px",
    wordBreak: "break-word",
  };

  const modalConfirmButton = (action) => (
    <Button
      disabled={isLoading}
      className="btn-lg btn-primary-custom"
      onClick={action}
    >
      {isLoading ? "Loading..." : "Yes"}
    </Button>
  );
  const modalCancelButton = (onClose) => (
    <Button variant="secondary" className="btn-lg" onClick={onClose}>
      No
    </Button>
  );

  return (
    <div
      style={{
        backgroundColor: "#f6f9ff",
        minHeight: "100%",
        paddingTop: "20px",
      }}
    >
      <div
        className="common_wrapper"
        style={{ width: "98%", backgroundColor: "white" }}
      >
        {/* Header */}
        <div
          className="card-header common_table_header"
          style={{ display: "flex", justifyContent: "space-between", gap: 10 }}
        >
          <div
            style={{
              fontSize: windowWidth < 600 ? "18px" : "20px",
              fontWeight: "600",
            }}
          >
            Vendor Management
          </div>

          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 16,
              justifyContent: windowWidth < 768 ? "flex-end" : "flex-start",
            }}
          >
            {[
              {
                value: activeTab,
                set: setActiveTab,
                options: ["ALL", "VERIFIED", "NOT_VERIFIED"],
              },
              {
                value: filterActive,
                set: setFilterActive,
                options: ["ALL", "ACTIVE", "INACTIVE"],
              },
            ].map((filter, i) => (
              <div
                key={i}
                style={{ position: "relative", display: "inline-block" }}
              >
                <FiFilter
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "8px",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                  }}
                />
                <select
                  style={{
                    padding: "4px 12px 4px 32px",
                    borderRadius: "4px",
                    fontSize: "16px",
                    border: "1px solid #e2e8f0",
                    appearance: "none",
                  }}
                  value={filter.value}
                  onChange={(e) => filter.set(e.target.value)}
                >
                  {filter.options.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt}
                    </option>
                  ))}
                </select>
              </div>
            ))}

            <div
              style={{
                display: "flex",
                width: windowWidth > 767 ? "25rem" : "12rem",
                backgroundColor: "white",
                borderRadius: "0.275rem",
                border: "1px solid #eee6e4",
              }}
            >
              <div
                style={{
                  width: "2.5rem",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IoSearch style={{ color: "#286A94", fontSize: "1.25rem" }} />
              </div>
              <input
                style={{
                  width: "100%",
                  paddingLeft: "0.5rem",
                  border: "none",
                  outline: "none",
                }}
                placeholder="Search by company, owner"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="card-body">
          <div className="table-responsive">
            <table
              style={{
                width: "100%",
                fontFamily: "Poppins, sans-serif",
                minWidth: "64rem",
                borderCollapse: "collapse",
              }}
            >
              <thead>
                <tr
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 2fr 2fr 1fr 1fr 1fr 1fr",
                    background: "#f9f9f9",
                  }}
                >
                  {tableHeaders.map((header, i) => (
                    <th
                      key={i}
                      style={{
                        padding: "0.5rem",
                        fontWeight: "600",
                        fontSize: "12px",
                      }}
                    >
                      {header.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loader ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <Spinner style={{ color: "#286a94", padding: "20px" }} />
                    </td>
                  </tr>
                ) : vendorData.length ? (
                  vendorData.map((vendor, i) => (
                    <tr
                      key={i}
                      style={{
                        display: "grid",
                        gridTemplateColumns: "2fr 2fr 2fr 1fr 1fr 1fr 1fr",
                        alignItems: "center",
                      }}
                    >
                      <td
                        style={{
                          ...tableCellStyle,
                          display: "flex",
                          alignItems: "center",
                          gap: 10,
                        }}
                      >
                        <img
                          src={vendor.companyLogoUrl || noImage}
                          alt="company"
                          style={{ width: 50, height: 50, borderRadius: "50%" }}
                        />
                        {vendor.company ?? "N/A"}
                      </td>
                      <td
                        style={{
                          ...tableCellStyle,
                          display: "flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        <img
                          src={vendor.vendorProfileImageUrl || noImage}
                          alt="vendor"
                          style={{ width: 50, height: 50, borderRadius: "50%" }}
                        />
                        {`${vendor.firstName ?? ""} ${vendor.lastName ?? ""}`}
                      </td>
                      <td style={tableCellStyle}>{vendor.email ?? "N/A"}</td>
                      <td style={tableCellStyle}>
                        {vendor.locations?.[0]?.state ?? "N/A"}
                      </td>

                      <td style={tableCellStyle}>
                        {vendor.isAccountVerified ? (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "4px 10px",
                              borderRadius: "20px",
                              backgroundColor: "#e0f7e9",
                              color: "#2e7d32",
                              fontWeight: 500,
                              fontSize: "12px",
                              boxShadow: "0 2px 5px rgba(46,125,50,0.2)",
                            }}
                          >
                            <FaCheckCircle /> Verified
                          </span>
                        ) : (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "4px 10px",
                              borderRadius: "20px",
                              backgroundColor: "#fff4e5",
                              color: "#f57c00",
                              fontWeight: 500,
                              fontSize: "12px",
                              boxShadow: "0 2px 5px rgba(211,47,47,0.2)",
                              transition: "transform 0.2s",
                              cursor: "default",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <FaTimesCircle /> Unverified
                          </span>
                        )}
                      </td>

                      <td style={tableCellStyle}>
                        {vendor.status ? (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "4px 10px",
                              borderRadius: "20px",
                              backgroundColor: "#e0f7e9",
                              color: "#2e7d32",
                              fontWeight: 500,
                              fontSize: "12px",
                              boxShadow: "0 2px 5px rgba(46,125,50,0.2)",
                              transition: "transform 0.2s",
                              cursor: "default",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <FaCheckCircle /> Activated
                          </span>
                        ) : (
                          <span
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 6,
                              padding: "4px 8px",
                              borderRadius: "20px",
                              backgroundColor: "#ffe5e5",
                              color: "#d32f2f",
                              fontWeight: 500,
                              fontSize: "12px",
                              boxShadow: "0 2px 5px rgba(211,47,47,0.2)",
                              transition: "transform 0.2s",
                              cursor: "default",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <FaTimesCircle /> Deactivated
                          </span>
                        )}
                      </td>

                      <td style={tableCellStyle}>
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            minWidth: 0,
                          }}
                        >
                          <FaEllipsisH
                            onClick={() => toggleOptions(vendor.vendorId)}
                            style={{ cursor: "pointer" }}
                          />
                          {showOptionsForId === vendor.vendorId && (
                            <div
                              ref={optionsRef}
                              style={{
                                position: "absolute",
                                right: 0,
                                top: "100%",
                                backgroundColor: "#fff",
                                border: "1px solid #e5e7eb",
                                borderRadius: "8px",
                                boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                zIndex: 100,
                                width: 150,
                                overflow: "hidden",
                              }}
                            >
                              {[
                                {
                                  label: "View",
                                  icon: <FaEye />,
                                  action: () =>
                                    navigate(
                                      `/admin/vendor/view?vendorId=${vendor.vendorId}`,
                                      { state: { active: activeTab } }
                                    ),
                                },
                                vendor.status
                                  ? {
                                      label: "Deactivate",
                                      icon: <MdDelete />,
                                      action: () => {
                                        setDeactivateModal(true);
                                        setId(vendor.vendorId);
                                      },
                                    }
                                  : {
                                      label: "Activate",
                                      icon: <MdAddTask />,
                                      action: () => {
                                        setActivateModal(true);
                                        setId(vendor.vendorId);
                                      },
                                    },
                              ].map((item, idx) => (
                                <div
                                  key={idx}
                                  onClick={item.action}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "10px 12px",
                                    cursor: "pointer",
                                    transition: "background 0.2s",
                                  }}
                                  onMouseEnter={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "#f1f5f9")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.currentTarget.style.backgroundColor =
                                      "#fff")
                                  }
                                >
                                  <span>{item.label}</span>
                                  {item.icon}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="text-center"
                      style={{ padding: "10px", fontWeight: 600 }}
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {vendorData.length > 0 && (
              <Pagination
                totalPages={totalPages}
                currentPage={pageNumber}
                onPageChange={handlePageChange}
              />
            )}
          </div>
        </div>
      </div>

      {/* Modals */}
      <Modal
        show={deactivateModal}
        onHide={() => {
          setDeactivateModal(false);
          setId(null);
        }}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Deactivate Vendor</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to deactivate this vendor?</Modal.Body>
        <Modal.Footer className="justify-content-center">
          {modalConfirmButton(handleDeactivate)}
          {modalCancelButton(() => {
            setDeactivateModal(false);
            setId(null);
          })}
        </Modal.Footer>
      </Modal>

      <Modal
        show={activateModal}
        onHide={() => {
          setActivateModal(false);
          setId(null);
        }}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Activate Vendor</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to activate this vendor?</Modal.Body>
        <Modal.Footer className="justify-content-center">
          {modalConfirmButton(handleActivate)}
          {modalCancelButton(() => {
            setActivateModal(false);
            setId(null);
          })}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default VendorPage;
